// A ESPERA DA MARCA: a animação da abertura (`maestra-splash.json`), a única espera de tela da web
// e do aplicativo (pedido do Lucas, 27/09/2026: eram três, e ficou só a colorida que termina no
// nome). As elipses entram coloridas e assentam na tinta da marca; o nome aparece depois.
//
// O arquivo vem com a tinta em branco ([1,1,1]) e o Lottie não herda `currentColor`: cada
// superfície pinta o JSON com a cor que tem à mão (o texto do tema na web, a tinta da tela no app).
// A pintura mora aqui para as duas darem a mesma cor ao mesmo quadro.

/** As medidas da espera, em pontos: o formato da animação é 3:1 (960×320). */
export const MEDIDAS_DA_ESPERA = { altura: 72, largura: 216 } as const;

/**
 * A ABERTURA NÃO SOME ANTES DO NOME, E NÃO FICA PARADA DEPOIS DELE (pedidos do Lucas, 27/09/2026).
 *
 * O arquivo tem 204 quadros, mas o último movimento (o nome assentando) é o 106: dali ao fim são
 * 1,6 s de imagem parada, que liam como tela travada. A espera toca só até `QUADRO_DO_NOME`, fica
 * `PAUSA_NO_NOME` no nome e sai num fade de `SAIDA_DA_ESPERA`. Sem movimento, a marca parada fica
 * o dobro da pausa, para dar tempo de ler.
 */
export const QUADRO_DO_NOME = 106;
export const PAUSA_NO_NOME = 300;
/** O fade de saída: o `moderate-02` do Carbon (240 ms). */
export const SAIDA_DA_ESPERA = 240;

const paraUnidade = (cor: string): [number, number, number] => {
  const hex = cor.trim().match(/^#([0-9a-f]{6})$/i);
  if (hex) {
    const h = hex[1];
    return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255) as [number, number, number];
  }
  const [r = 0, g = 0, b = 0] = (cor.match(/\d+(\.\d+)?/g) ?? []).map(Number);
  return [r / 255, g / 255, b / 255];
};

/**
 * Troca o branco da animação pela `cor` (`#rrggbb` ou `rgb(r, g, b)`): a cor parada (`k`) e o
 * quadro-chave em que as elipses assentam (`s`). As cores dos outros quadros ficam.
 */
export const pintarMarca = <T>(dados: T, cor: string): T => {
  const [r, g, b] = paraUnidade(cor);
  return JSON.parse(JSON.stringify(dados).replace(/"(k|s)":\[1,1,1\]/g, `"$1":[${r},${g},${b}]`));
};
